import { render, staticRenderFns } from "./ContractEditorFieldset.yaml?vue&type=template&id=0a0b5983&component"
import script from "./ContractEditorFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./ContractEditorFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports